
import Vue from 'vue';
import InputStyle from '@/components/Forms/InputStyle.vue';
import InputMixin from '@/components/Forms/InputMixin';
import debounce from '@/directives/vDebounce';

export default Vue.extend({
  props: {
    type: {
      type: String,
      default: 'text',
    },
  },
  components: {
    InputStyle,
  },
  directives: { debounce },
  mixins: [InputMixin],
});
